import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('initialise_virtualiser_state_from_relay_store');
	},
};
